import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIconjarComponent } from './simple-icons-iconjar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIconjarComponent ],
    exports:      [ SimpleIconsIconjarComponent ],
    bootstrap:    []
})
export class SimpleIconsIconjarModule {}
